module.exports = __webpack_public_path__ + "img/source_mian-line3.58405485.png";